import type { PropsWithChildren, Ref } from "react";
import { forwardRef } from "react";
import clsx from "clsx";

import classes from "./styles.module.scss";

import type { IBoxProps } from ".";

export const Box = forwardRef(function Box(
  props: PropsWithChildren<IBoxProps>,
  ref: Ref<HTMLDivElement>,
) {
  const {
    px,
    py,
    radius,
    borderNone,
    shadow,
    className,
    w100,
    borderStyle = "solid",
    children,
    backgroundColor = "primary-background",
    borderColor = "border-main",
    ...htmlAttribute
  } = props;

  return (
    <div
      ref={ref}
      className={clsx([
        `px-${px}`,
        `py-${py}`,
        `rounded-${radius}`,

        `bg-color-${backgroundColor}`,
        !borderNone && `border-color-${borderColor}`,
        w100 ? "w-100" : "",
        borderNone ? "" : [classes.border, `border-style-${borderStyle}`],
        shadow ? classes.shadow : "",
        className,
      ])}
      {...htmlAttribute}
    >
      {children}
    </div>
  );
});
